import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import * as dateUtils from '../../calendar/generic-utils/dateUtils/index.esm.js';
import '../../calendar/CalendarBase/calendar/index.esm.js';
import '../../calendar/CalendarNavigation/calendar-navigation-pagination/index.esm.js';
import '../../calendar/CalendarNavigation/calendar-navigation-scrolling/index.esm.js';
import '../../styles/uitk-egds-calendar.css';
import '../../calendar/DayTemplateToolkit/ToolkitComponents/date-number/index.esm.js';
import '../../calendar/DayTemplateToolkit/ToolkitComponents/availability-background/index.esm.js';
import '../../calendar/DayTemplateToolkit/ToolkitComponents/EventBar/event-bar/index.esm.js';
import '../../calendar/DayTemplateToolkit/ToolkitComponents/EventBar/bar-style/index.esm.js';
import '../../calendar/DayTemplateToolkit/ToolkitComponents/Legend/legend-swatches/index.esm.js';
import '../../calendar/types/index.esm.js';
import '../../input/input/index.esm.js';
import '../../input/faux-input/index.esm.js';
import '../../input/password-input/index.esm.js';
import '../../input/informative-input/index.esm.js';
import '../../input/textarea/index.esm.js';
import '../../input/chat-textarea/index.esm.js';
import { EGDSFakeInput } from '../../input/fake-input/index.esm.js';
import '../../input/card-number-input/index.esm.js';
import '../../input/select/index.esm.js';
import '../../input/swapper-input/index.esm.js';
import '../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../layout-flex/layout-flex-item/index.esm.js';
import { useLocalization } from '@shared-ui/localization-context';
import { Viewport, ViewSmall, ViewMedium } from '@shared-ui/viewport-context';
const {
  getEffectiveConsolidatedDateString,
  getEffectiveDateText
} = dateUtils;
const EGDSDateSelectorInputs = props => {
  const l10n = useLocalization();
  const defaultInputLabel1 = l10n.formatText('dateSelector.startDate.label');
  const defaultInputLabel2 = l10n.formatText('dateSelector.endDate.label');
  const {
    dialogId,
    input1Stid,
    input2Stid,
    dateFormatOptions,
    endDate,
    handleClickInput1,
    handleClickInput2,
    input1Ref,
    input2Ref,
    inputIcon1 = 'today',
    inputIcon2 = 'today',
    inputLabel1 = defaultInputLabel1,
    inputLabel2 = defaultInputLabel2,
    inputName1,
    inputName2,
    invalidInput1,
    invalidInput2,
    isSingleDateSelection,
    locale,
    required,
    startDate,
    trailingText1,
    trailingText2,
    useSingleTrigger,
    inputValue1: customInputValue1,
    inputValue2: customInputValue2,
    isOpen = false
  } = props;
  const firstInputDataStid = `uitk-date-selector-input1-${input1Stid ?? dialogId}`;
  const secondInputDataStid = `uitk-date-selector-input2-${input2Stid ?? dialogId}`;
  const [openedInput, setOpenedInput] = React.useState(null);
  const isMultiInput = React.useMemo(() => !isSingleDateSelection && !useSingleTrigger, [isSingleDateSelection, useSingleTrigger]);
  const [inputValue1, inputValue2] = React.useMemo(() => {
    const input1 = useSingleTrigger ? getEffectiveConsolidatedDateString(startDate ?? '', endDate ?? '', locale, dateFormatOptions) : getEffectiveDateText(startDate, locale, dateFormatOptions);
    const input2 = getEffectiveDateText(endDate, locale, dateFormatOptions);
    return [input1, input2];
  }, [dateFormatOptions, endDate, locale, startDate, useSingleTrigger]);
  const [inputId1, inputId2] = React.useMemo(() => [Math.random().toString(36).substring(7), Math.random().toString(36).substring(7)], []);
  const handleClickInput1Modified = e => {
    handleClickInput1(e);
    setOpenedInput('input1');
  };
  const handleClickInput2Modified = e => {
    handleClickInput2(e);
    setOpenedInput('input2');
  };
  return jsxs(EGDSLayoutFlex, {
    direction: "row",
    space: "three",
    children: [jsx(EGDSLayoutFlexItem, {
      grow: 1,
      maxWidth: isMultiInput ? 'half_width' : 'full_width',
      children: jsx("div", {
        children: jsxs(Viewport, {
          children: [jsx(ViewSmall, {
            children: jsx(EGDSFakeInput, {
              "data-testid": firstInputDataStid,
              "data-stid": firstInputDataStid,
              domRef: input1Ref,
              icon: inputIcon1,
              id: inputId1,
              label: inputLabel1,
              name: inputName1,
              onClick: handleClickInput1Modified,
              required: required,
              value: customInputValue1 ?? inputValue1,
              trailingText: trailingText1,
              invalid: invalidInput1,
              "aria-invalid": !!invalidInput1,
              "aria-describedby": `${inputId1}-error`
            })
          }), jsx(ViewMedium, {
            children: jsx(EGDSFakeInput, {
              "data-testid": firstInputDataStid,
              "data-stid": firstInputDataStid,
              domRef: input1Ref,
              icon: inputIcon1,
              id: inputId1,
              label: inputLabel1,
              name: inputName1,
              onClick: handleClickInput1Modified,
              required: required,
              value: customInputValue1 ?? inputValue1,
              trailingText: trailingText1,
              invalid: invalidInput1,
              "aria-invalid": !!invalidInput1,
              "aria-describedby": `${inputId1}-error`,
              "aria-expanded": isOpen && openedInput === 'input1'
            })
          })]
        })
      })
    }), isMultiInput && jsx(EGDSLayoutFlexItem, {
      grow: 1,
      maxWidth: "half_width",
      children: jsx("div", {
        children: jsxs(Viewport, {
          children: [jsx(ViewSmall, {
            children: jsx(EGDSFakeInput, {
              "data-testid": secondInputDataStid,
              "data-stid": secondInputDataStid,
              domRef: input2Ref,
              icon: inputIcon2,
              id: inputId2,
              label: inputLabel2,
              name: inputName2,
              onClick: handleClickInput2Modified,
              required: required,
              value: customInputValue2 ?? inputValue2,
              trailingText: trailingText2,
              invalid: invalidInput2,
              "aria-invalid": !!invalidInput2,
              "aria-describedby": `${inputId2}-error`
            })
          }), jsx(ViewMedium, {
            children: jsx(EGDSFakeInput, {
              "data-testid": secondInputDataStid,
              "data-stid": secondInputDataStid,
              domRef: input2Ref,
              icon: inputIcon2,
              id: inputId2,
              label: inputLabel2,
              name: inputName2,
              onClick: handleClickInput2Modified,
              required: required,
              value: customInputValue2 ?? inputValue2,
              trailingText: trailingText2,
              invalid: invalidInput2,
              "aria-invalid": !!invalidInput2,
              "aria-describedby": `${inputId2}-error`,
              "aria-expanded": isOpen && openedInput === 'input2'
            })
          })]
        })
      })
    })]
  });
};
EGDSDateSelectorInputs.displayName = 'EGDSDateSelectorInputs';
export { EGDSDateSelectorInputs };